<div class='acc-delivery-graduation-tab-part'>

	@if(ventureStatusCount(); as count){
	<table class='pro-table pro-table-without-border pro-table-with-thin-rows w-100'>
		<tr>
			<th>Ventures Info</th>
			<th>Value</th>
		</tr>
		<tr>
			<td>Total Accepted Ventures</td>
			<td>{{count.totalVentures}}</td>
		</tr>
		<tr>
			<td>Total Undecided Ventures</td>
			<td>{{count.Participating}}</td>
		</tr>
		<tr>
			<td>Total Dropped Ventures</td>
			<td>{{count['Dropped Out'] + count['Never Started']}}</td>
		</tr>
		<tr>
			<td>Total Graduated Ventures</td>
			<td>{{count.Graduated}}</td>
		</tr>
	</table>
	}
</div>